import {gql} from "@apollo/client";

export const adventureCharacterUpdate = gql`
    subscription adventureCharacterUpdate($characterIds: [Int]!) {
        adventureCharacterUpdate(characterIds: $characterIds) {
            characterName
            CharacterSheet {
                currentHitpoints
            }
        }
    }
`

export const singleCharacterUpdate = gql`
    subscription SingleCharacterUpdate($characterId: Int!) {
        singleCharacterUpdate(characterId: $characterId) {
            characterExp
            characterId
            characterLevel
            characterName
            User {
                userName
                userId
            }
            Subrace {
                subraceDescription
                subraceId
                subraceName
                subraceFeatures {
                    subraceFeatureId
                    subraceFeatureName
                    subraceFeatureDesc
                }
            }
            Race {
                raceId
                raceName
                raceDescription
                raceFeatures {
                    raceFeatureId
                    raceFeatureName
                    raceFeatureDesc
                }
            }
            character_to_class {
                level
                Class {
                    hitdie
                    classSpellCast
                    className
                    classDescription
                    classId
                    subclassLevel
                    Mana {
                        manaMaxSpells
                        manaMaxSpellLevel
                        manaLevel
                        manaId
                        manaCantrips
                        manaAmount
                    }
                    ClassFeature {
                        classFeatureName
                        classFeatureId
                        classFeatureDesc
                        onLevel
                    }
                }
                Subclass {
                    subClassSpellCast
                    subclassDescription
                    subclassId
                    subclassName
                    Mana {
                        manaAmount
                        manaCantrips
                        manaId
                        manaLevel
                        manaMaxSpells
                        manaMaxSpellLevel
                    }
                    SubclassFeature {
                        onLevel
                        subclassFeatureDesc
                        subclassFeatureId
                        subclassFeatureName
                    }
                }
            }

            CharacterSheet {
                spellSaveDc
                spellAttackModifier
                silver
                gold
                skill_to_characterSheet {
                    proficiencyAmount
                    value
                    skill_to_characterSheetId
                    Skill {
                        skillName
                        skillId
                    }
                }
                lifepoints
                currentHitpoints
                temporaryHitpoints
                currentMana
                languages
                language_to_characterSheet {
                    language_to_characterSheetId
                    Language {
                        languageName
                        languageId
                    }
                }
                initiative
                armorClass
                ability_to_characterSheet {
                    proficiencyAmount
                    value
                    ability_to_characterSheetId
                    Ability {
                        abilityId
                        abilityName
                    }
                }
                Spell {
                    isConcentration
                    isActive
                    savingThrow {
                        abilityId
                        abilityName
                    }
                    spellComponents
                    spellCost
                    spellId
                    spellName
                    spellDuration
                    spellTarget
                    spellText
                    spellType
                }
                Note {
                    noteText
                    noteId
                    noteHeading
                }
                Item {
                    itemId
                    itemDescription
                    itemAmount
                }
                characterSheetId
            }
            Adventure {
                adventureId
            }
        }
    }
`

export const listenToAdventure = gql`
    subscription ListenToAdventure($adventureId: Int!) {
        listenToAdventure(adventureId: $adventureId) {
            adventureId
            adventureDescription
            adventureName
            Character {
                characterId
                characterName
                User {
                    userId
                }
            }
            user_to_adventure {
                userToAdventureId
                User {
                    userName
                    userId
                    userRole
                    Character {
                        characterName
                        characterId
                        CharacterSheet {
                            currentHitpoints
                            lifepoints
                        }
                    }
                }
            }
        }
    }
`